import { useEffect, useRef } from "react";
import { useAuth } from "hooks/useAuth";
import { useNavigate } from "react-router-dom";
import authService from "services/authService";

const INACTIVITY_LIMIT = 3 * 60 * 1000; // 5 minutos
const VERIFY_INTERVAL = 10 * 1000; // cada 1 minuto

export const AuthWatcher = ({ children }) => {
  const { isLogged, logout } = useAuth();
  const navigate = useNavigate();

  const inactivityTimer = useRef(null);
  const verifyInterval = useRef(null);

  // 🔁 Resetear timer de inactividad
  const resetInactivityTimer = () => {
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }

    inactivityTimer.current = setTimeout(() => {
      console.log("⏱️ Logout por inactividad");
      logout();
      navigate("/");
    }, INACTIVITY_LIMIT);
  };

  // 👀 Detectar actividad del usuario
  useEffect(() => {
    if (!isLogged) return;

    const events = ["mousemove", "keydown", "click", "scroll"];

    const handleActivity = () => {
      resetInactivityTimer();
    };

    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    resetInactivityTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      clearTimeout(inactivityTimer.current);
    };
  }, [isLogged]);

  // 🔐 Verificar token periódicamente
  useEffect(() => {
    if (!isLogged) return;

    verifyInterval.current = setInterval(async () => {
      const res = await authService.verifyToken();

      if (res.error) {
        console.log("🔐 Token inválido o expirado");
        logout();
        navigate("/");
      }
    }, VERIFY_INTERVAL);

    return () => clearInterval(verifyInterval.current);
  }, [isLogged]);

  return children;
};